import People from '@material-ui/icons/People';

import List from './List';

export default {
  list: List,
  icon: People,
};
